if (!customElements.get('rad-rugged-accessories')) {
  customElements.define('rad-rugged-accessories', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.busy = false;
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency', currency:this.dataset.currency || 'USD'});
      this.rows = [...this.querySelectorAll('[data-item]')];
      this.addEventListener('change', () => this.updateTotal());
      this.addEventListener('input', () => this.updateTotal());
      this.addEventListener('click', event => {
        const add = event.target.closest('[data-add]');
        if (add) this.addRows([add.closest('[data-item]')]);
        if (event.target.closest('[data-add-selected]')) this.addRows(this.rows.filter(row => row.querySelector('[data-include]').checked));
      });
      this.updateTotal();
    }
    selection(row) {
      const option = row.querySelector('[data-variant]').selectedOptions[0];
      const quantity = Number(row.querySelector('[data-quantity]').value);
      if (!option?.value || option.dataset.available !== 'true' || !Number.isSafeInteger(quantity) || quantity < 1) return null;
      return {id:option.value, quantity, price:Number(option.dataset.price)};
    }
    updateTotal() {
      let total = 0;
      this.rows.forEach(row => {
        const selected = this.selection(row);
        const option = row.querySelector('[data-variant]').selectedOptions[0];
        if (option?.value) row.querySelector('[data-price]').firstChild.textContent = this.money.format(Number(option.dataset.price) / 100) + ' ';
        if (row.querySelector('[data-include]').checked && selected) total += selected.price * selected.quantity;
      });
      this.querySelector('[data-total]').textContent = this.money.format(total / 100);
    }
    async addRows(rows) {
      if (this.busy) return;
      const status = this.querySelector('[data-status]');
      status.textContent = '';
      if (!rows.length) { status.textContent = this.dataset.empty; return; }
      let invalid = false;
      const selections = rows.map(row => {
        const item = this.selection(row);
        row.querySelector('[data-message]').textContent = item ? '' : this.dataset.choose;
        if (!item && !invalid) {
          const details = row.closest('details');
          if (details) details.open = true;
          (row.querySelector('[data-variant]').value ? row.querySelector('[data-quantity]') : row.querySelector('[data-variant]')).focus();
          invalid = true;
        }
        return item;
      });
      if (invalid) return;
      this.busy = true;
      const buttons = [...this.querySelectorAll('button')];
      const states = buttons.map(button => button.disabled);
      buttons.forEach(button => button.disabled = true);
      status.textContent = this.dataset.adding;
      const merged = new Map();
      selections.forEach(({id,quantity}) => merged.set(id, (merged.get(id) || 0) + quantity));
      const items = [...merged].map(([id,quantity]) => ({id,quantity}));
      try {
        const response = await fetch((this.dataset.root || '/').replace(/\/?$/, '/') + 'cart/add.js', {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items})
        });
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
        rows.forEach(row => {
          row.querySelector('[data-message]').textContent = this.dataset.added;
          row.querySelector('[data-include]').checked = false;
        });
        status.textContent = this.dataset.added;
        this.updateTotal();
        document.documentElement.dispatchEvent(new CustomEvent('theme:cartchanged', {bubbles:true, detail:{openDrawer:true}}));
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
      } finally {
        buttons.forEach((button,index) => button.disabled = states[index]);
        this.busy = false;
      }
    }
  });
}
